import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updatePlaceImage = async (placeId, file) => {
  if (!placeId || !file) {
    console.log('NO PLACE ID');
    return;
  }
  let data = new FormData();
  data.append('file', file);

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/image`,
    data,
  });
};